export default __webpack_public_path__ + "static/media/money-envelope.c4cdc20b.svg";